import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2';
// import * as addonService from '../../../services/addons.service';
import { handleServerValidations } from '../../../../../utils/commonfunction';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { SWAL_SETTINGS } from '../../../../../utils/Constants';
import { useTranslation } from 'react-i18next';
import { getThemeCustomizerUpdate, themeCustomizerUpadte } from '../../../services/themeCustomizer.services';
import { error } from 'jquery';
import trash from "../../../../../assets/restaurant/images/trash.svg";

export default function ThemeCustomizer() {

  const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
  const [addResetSettingLoader, setAddResetSettingLoader] = useState(false);
  const [themeData, setThemeData] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    getThemeCustomizerUpdate().then((response) => {
      setThemeData(response && response.data ? response.data : []);
    }).catch((error) => {
      console.log("error=====>", error)
    })
  }, [])

  const updateThemeCustomizer = useFormik({
    initialValues: {
      light_theme_colors: themeData && themeData.light_theme_colors ? themeData.light_theme_colors : {
        primary_color: "",
        background_color: "",
        header_color_background: "",
        header_color_icon: "",
        header_color_text: "",
        sidebar_color_background: "",
        sidebar_color_icon: "",
        sidebar_color_text: "",
      },
      dark_theme_colors: themeData && themeData.dark_theme_colors ? themeData.dark_theme_colors : {
        primary_color: "",
        background_color: "",
        header_color_background: "",
        header_color_icon: "",
        header_color_text: "",
        sidebar_color_background: "",
        sidebar_color_icon: "",
        sidebar_color_text: "",
      },
    },
   
    enableReinitialize: true,
    onSubmit: (values) => {
      setAddSubmissionLoader(true);
      let payload = {
        light_theme_colors: JSON.stringify({ ...values.light_theme_colors }),
        dark_theme_colors: JSON.stringify({ ...values.dark_theme_colors }),
      };
      themeCustomizerUpadte(payload).then((response) => {
        setAddSubmissionLoader(false);
        if (response.success) {
          Swal.fire({
            icon: "success",
            text: "Theme updated successfully",
            ...SWAL_SETTINGS,
          });
          // resetForm();
        } else {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(response),
            ...SWAL_SETTINGS,
          });
        }
      }).catch((error) => {
        setAddSubmissionLoader(false);
        console.error("Error updating profile", error);
      });
    },
  });

  const handleResetSetting = () => {
    Swal.fire({
      title: t("Are you sure?"),
      text: t("This action will reset settings. Proceed?"),
      imageUrl: trash,
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("Yes"),
      cancelButtonText: t("Cancel"),
      reverseButtons: true,
      customClass: {
        popup: "swal-restaurant",
        confirmButton: "btn btn-danger col",
        cancelButton: "btn btn-secondary col",
      },
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        setAddResetSettingLoader(true);

        let resetPayload = {
          light_theme_colors: JSON.stringify({
            primary_color: null,
            background_color: null,
            header_color_background: null,
            header_color_icon: null,
            header_color_text: null,
            sidebar_color_background: null,
            sidebar_color_icon: null,
            sidebar_color_text: null,
          }),
          dark_theme_colors: JSON.stringify({
            primary_color: null,
            background_color: null,
            header_color_background: null,
            header_color_icon: null,
            header_color_text: null,
            sidebar_color_background: null,
            sidebar_color_icon: null,
            sidebar_color_text: null,
          }),
        };

        themeCustomizerUpadte(resetPayload)
          .then((response) => {
            setAddResetSettingLoader(false);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: t("Theme settings reset successfully!"),
                ...SWAL_SETTINGS,
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            setAddResetSettingLoader(false);
            console.error("Error resetting theme settings", error);
          });
      }
    });
  };

  const isLightThemeFilled = Object.values(updateThemeCustomizer.values?.light_theme_colors || {}).some(value => value && value.toString().trim() !== '');
  const isDarkThemeFilled = Object.values(updateThemeCustomizer.values?.dark_theme_colors || {}).some(value => value && value.toString().trim() !== '');

  const isFormFilled = isLightThemeFilled || isDarkThemeFilled;


  return (
    <main id='main-content'>
      <div className='inner-container'>
        <h1 className="mb-4">Theme Customizer</h1>
        <div className='card'>
          <div className='card-body'>
            <div className='color-changer-wrap'>
              <form onSubmit={updateThemeCustomizer.handleSubmit}>
                <div className='color-changer-row'>
                  <h2 className='mb-2'>Light Theme Colors</h2>
                  {/* <h4 className='mb-2'>Main Color</h4> */}
                  <div className='row'>
                    <div className='col-md-6'>
                      <div className='color-input'>
                        <label className='form-label'>Primary Color</label>
                        {/* <input type='text' className='form-control' value={'#FF3377'} /> */}
                        <input
                          id="light_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Primary Color"
                          name="light_theme_colors.primary_color"
                          value={updateThemeCustomizer.values?.light_theme_colors?.primary_color}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.light_theme_colors?.primary_color &&
                          updateThemeCustomizer.errors?.light_theme_colors?.primary_color ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.light_theme_colors.primary_color)}
                          </div>
                        ) : null}
                        <input type='color' className='form-control-color' value={updateThemeCustomizer?.values?.light_theme_colors?.primary_color} onChange={e => updateThemeCustomizer?.setFieldValue('light_theme_colors.primary_color', e?.target?.value)} />
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='color-input'>
                        <label className='form-label'>Background Color</label>
                        {/* <input type='text' className='form-control' value={'#FF3377'} /> */}
                        <input
                          id="light_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Background Color"
                          name="light_theme_colors.background_color"
                          value={updateThemeCustomizer.values?.light_theme_colors?.background_color}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.light_theme_colors?.background_color &&
                          updateThemeCustomizer.errors?.light_theme_colors?.background_color ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.light_theme_colors.background_color)}
                          </div>
                        ) : null}

                        <input type='color' className='form-control-color' value={updateThemeCustomizer?.values?.light_theme_colors?.background_color} onChange={e => updateThemeCustomizer?.setFieldValue('light_theme_colors.background_color', e.target.value)} />
                      </div>
                    </div>
                  </div>
                </div>
                <hr className='my-4'></hr>
                <div className='color-changer-row'>
                  <h4 className='mb-2'>Header Color</h4>
                  <div className='row'>
                    <div className='col-md-4'>
                      <div className='color-input'>
                        <label className='form-label'>Background</label>
                        {/* <input type='text' className='form-control' value={'#FF3377'} /> */}
                        <input
                          id="light_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Background"
                          name="light_theme_colors.header_color_background"
                          value={updateThemeCustomizer?.values?.light_theme_colors?.header_color_background}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.light_theme_colors?.header_color_background &&
                          updateThemeCustomizer.errors?.light_theme_colors?.header_color_background ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.light_theme_colors.header_color_background)}
                          </div>
                        ) : null}

                        <input type='color' className='form-control-color' value={updateThemeCustomizer?.values?.light_theme_colors?.header_color_background} onChange={e => updateThemeCustomizer?.setFieldValue('light_theme_colors.header_color_background', e.target.value)} />
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='color-input'>
                        <label className='form-label'>Icon</label>
                        {/* <input type='text' className='form-control' value={'#FF3377'} /> */}
                        <input
                          id="light_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Icon"
                          name="light_theme_colors.header_color_icon"
                          value={updateThemeCustomizer?.values?.light_theme_colors?.header_color_icon}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.light_theme_colors?.header_color_icon &&
                          updateThemeCustomizer.errors?.light_theme_colors?.header_color_icon ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.light_theme_colors.header_color_icon)}
                          </div>
                        ) : null}

                        <input type='color' className='form-control-color' value={updateThemeCustomizer?.values?.light_theme_colors?.header_color_icon} onChange={e => updateThemeCustomizer?.setFieldValue('light_theme_colors.header_color_icon', e.target.value)} />
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='color-input'>
                        <label className='form-label'>Text</label>
                        {/* <input type='text' className='form-control' value={'#FF3377'} /> */}
                        <input
                          id="light_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Text"
                          name="light_theme_colors.header_color_text"
                          value={updateThemeCustomizer?.values?.light_theme_colors?.header_color_text}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.light_theme_colors?.header_color_text &&
                          updateThemeCustomizer.errors?.light_theme_colors?.header_color_text ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.light_theme_colors.header_color_text)}
                          </div>
                        ) : null}

                        <input type='color' className='form-control-color' value={updateThemeCustomizer?.values?.light_theme_colors?.header_color_text} onChange={e => updateThemeCustomizer?.setFieldValue('light_theme_colors.header_color_text', e.target.value)} />
                      </div>
                    </div>
                  </div>
                </div>
                <hr className='my-4'></hr>
                <div className='color-changer-row'>
                  <h4 className='mb-2'>Sidebar Color</h4>
                  <div className='row'>
                    <div className='col-md-4'>
                      <div className='color-input'>
                        <label className='form-label'>Background</label>
                        {/* <input type='text' className='form-control' value={'#FF3377'} /> */}
                        <input
                          id="light_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Background"
                          name="light_theme_colors.sidebar_color_background"
                          value={updateThemeCustomizer?.values?.light_theme_colors?.sidebar_color_background}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.light_theme_colors?.sidebar_color_background &&
                          updateThemeCustomizer.errors?.light_theme_colors?.sidebar_color_background ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.light_theme_colors.sidebar_color_background)}
                          </div>
                        ) : null}

                        <input type='color' className='form-control-color' value={updateThemeCustomizer?.values?.light_theme_colors?.sidebar_color_background} onChange={e => updateThemeCustomizer?.setFieldValue('light_theme_colors.sidebar_color_background', e.target.value)} />
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='color-input'>
                        <label className='form-label'>Icon</label>
                        {/* <input type='text' className='form-control' value={'#FF3377'} /> */}
                        <input
                          id="light_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Icon"
                          name="light_theme_colors.sidebar_color_icon"
                          value={updateThemeCustomizer?.values?.light_theme_colors?.sidebar_color_icon}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.light_theme_colors?.sidebar_color_icon &&
                          updateThemeCustomizer.errors?.light_theme_colors?.sidebar_color_icon ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.light_theme_colors.sidebar_color_icon)}
                          </div>
                        ) : null}

                        <input type='color' className='form-control-color' value={updateThemeCustomizer?.values?.light_theme_colors?.sidebar_color_icon} onChange={e => updateThemeCustomizer?.setFieldValue('light_theme_colors.sidebar_color_icon', e.target.value)} />
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='color-input'>
                        <label className='form-label'>Text</label>
                        {/* <input type='text' className='form-control' value={'#FF3377'} /> */}
                        <input
                          id="light_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Text"
                          name="light_theme_colors.sidebar_color_text"
                          value={updateThemeCustomizer?.values?.light_theme_colors?.sidebar_color_text}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.light_theme_colors?.sidebar_color_text &&
                          updateThemeCustomizer.errors?.light_theme_colors?.sidebar_color_text ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.light_theme_colors.sidebar_color_text)}
                          </div>
                        ) : null}

                        <input type='color' className='form-control-color' value={updateThemeCustomizer?.values?.light_theme_colors?.sidebar_color_text} onChange={e => updateThemeCustomizer?.setFieldValue('light_theme_colors.sidebar_color_text', e.target.value)} />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className='color-changer-wrap mt-4'>
              <form onSubmit={updateThemeCustomizer.handleSubmit}>
                <div className='color-changer-row'>
                  <h2 className='mb-2'>Dark Theme Colors</h2>
                  <div className='row'>
                    <div className='col-md-6'>
                      <div className='color-input'>
                        <label className='form-label'>Primary Color</label>
                        <input
                          id="dark_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Primary Color"
                          name="dark_theme_colors.primary_color"
                          value={updateThemeCustomizer?.values?.dark_theme_colors?.primary_color}
                          // value={updateThemeCustomizer.values.dark_theme_primary_color}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.dark_theme_colors?.primary_color &&
                          updateThemeCustomizer.errors?.dark_theme_colors?.primary_color ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.dark_theme_colors.primary_color)}
                          </div>
                        ) : null}
                        <input type='color' className='form-control-color' value={updateThemeCustomizer?.values?.dark_theme_colors?.primary_color} onChange={e => updateThemeCustomizer?.setFieldValue('dark_theme_colors.primary_color', e?.target?.value)} />
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='color-input'>
                        <label className='form-label'>Background Color</label>
                        {/* <input type='text' className='form-control' value={'#FF3377'} /> */}
                        <input
                          id="dark_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Background Color"
                          name="dark_theme_colors.background_color"
                          value={updateThemeCustomizer.values.dark_theme_colors.background_color}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.dark_theme_colors?.background_color &&
                          updateThemeCustomizer.errors?.dark_theme_colors?.background_color ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.dark_theme_colors.background_color)}
                          </div>
                        ) : null}

                        <input type='color' className='form-control-color' value={updateThemeCustomizer.values.dark_theme_colors.background_color} onChange={e => updateThemeCustomizer?.setFieldValue('dark_theme_colors.background_color', e.target.value)} />
                      </div>
                    </div>
                  </div>
                </div>
                <hr className='my-4'></hr>
                <div className='color-changer-row'>
                  <h4 className='mb-2'>Header Color</h4>
                  <div className='row'>
                    <div className='col-md-4'>
                      <div className='color-input'>
                        <label className='form-label'>Background</label>
                        {/* <input type='text' className='form-control' value={'#FF3377'} /> */}
                        <input
                          id="dark_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Background"
                          name="dark_theme_colors.header_color_background"
                          value={updateThemeCustomizer.values.dark_theme_colors.header_color_background}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.dark_theme_colors?.header_color_background &&
                          updateThemeCustomizer.errors?.dark_theme_colors?.header_color_background ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.dark_theme_colors.header_color_background)}
                          </div>
                        ) : null}

                        <input type='color' className='form-control-color' value={updateThemeCustomizer.values.dark_theme_colors.header_color_background} onChange={e => updateThemeCustomizer?.setFieldValue('dark_theme_colors.header_color_background', e.target.value)} />
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='color-input'>
                        <label className='form-label'>Icon</label>
                        {/* <input type='text' className='form-control' value={'#FF3377'} /> */}
                        <input
                          id="dark_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Icon"
                          name="dark_theme_colors.header_color_icon"
                          value={updateThemeCustomizer.values.dark_theme_colors.header_color_icon}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.dark_theme_colors?.header_color_icon &&
                          updateThemeCustomizer.errors?.dark_theme_colors?.header_color_icon ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.dark_theme_colors.header_color_icon)}
                          </div>
                        ) : null}

                        <input type='color' className='form-control-color' value={updateThemeCustomizer.values.dark_theme_colors.header_color_icon} onChange={e => updateThemeCustomizer?.setFieldValue('dark_theme_colors.header_color_icon', e.target.value)} />
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='color-input'>
                        <label className='form-label'>Text</label>
                        {/* <input type='text' className='form-control' value={'#FF3377'} /> */}
                        <input
                          id="dark_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Text"
                          name="dark_theme_colors.header_color_text"
                          value={updateThemeCustomizer.values.dark_theme_colors.header_color_text}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.dark_theme_colors?.header_color_text &&
                          updateThemeCustomizer.errors?.dark_theme_colors?.header_color_text ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.dark_theme_colors.header_color_text)}
                          </div>
                        ) : null}

                        <input type='color' className='form-control-color' value={updateThemeCustomizer.values.dark_theme_colors.header_color_text} onChange={e => updateThemeCustomizer?.setFieldValue('dark_theme_colors.header_color_text', e.target.value)} />
                      </div>
                    </div>
                  </div>
                </div>
                <hr className='my-4'></hr>
                <div className='color-changer-row'>
                  <h4 className='mb-2'>Sidebar Color</h4>
                  <div className='row'>
                    <div className='col-md-4'>
                      <div className='color-input'>
                        <label className='form-label'>Background</label>
                        {/* <input type='text' className='form-control' value={'#FF3377'} /> */}
                        <input
                          id="dark_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Background"
                          name="dark_theme_colors.sidebar_color_background"
                          value={updateThemeCustomizer.values.dark_theme_colors.sidebar_color_background}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.dark_theme_colors?.sidebar_color_background &&
                          updateThemeCustomizer.errors?.dark_theme_colors?.sidebar_color_background ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.dark_theme_colors.sidebar_color_background)}
                          </div>
                        ) : null}

                        <input type='color' className='form-control-color' value={updateThemeCustomizer.values.dark_theme_colors.sidebar_color_background} onChange={e => updateThemeCustomizer?.setFieldValue('dark_theme_colors.sidebar_color_background', e.target.value)} />
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='color-input'>
                        <label className='form-label'>Icon</label>
                        {/* <input type='text' className='form-control' value={'#FF3377'} /> */}
                        <input
                          id="dark_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Icon"
                          name="dark_theme_colors.sidebar_color_icon"
                          value={updateThemeCustomizer.values.dark_theme_colors.sidebar_color_icon}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.dark_theme_colors?.sidebar_color_icon &&
                          updateThemeCustomizer.errors?.dark_theme_colors?.sidebar_color_icon ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.dark_theme_colors.sidebar_color_icon)}
                          </div>
                        ) : null}

                        <input type='color' className='form-control-color' value={updateThemeCustomizer.values.dark_theme_colors.sidebar_color_icon} onChange={e => updateThemeCustomizer?.setFieldValue('dark_theme_colors.sidebar_color_icon', e.target.value)} />
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='color-input'>
                        <label className='form-label'>Text</label>
                        {/* <input type='text' className='form-control' value={'#FF3377'} /> */}
                        <input
                          id="dark_theme_colors"
                          type="text"
                          className="form-control"
                          placeholder="Text"
                          name="dark_theme_colors.sidebar_color_text"
                          value={updateThemeCustomizer.values.dark_theme_colors.sidebar_color_text}
                          onChange={updateThemeCustomizer.handleChange}
                          onBlur={updateThemeCustomizer.handleBlur}
                        />
                        {updateThemeCustomizer.touched?.dark_theme_colors?.sidebar_color_text &&
                          updateThemeCustomizer.errors?.dark_theme_colors?.sidebar_color_text ? (
                          <div className="text-danger">
                            {t(updateThemeCustomizer.errors.dark_theme_colors.sidebar_color_text)}
                          </div>
                        ) : null}

                        <input type='color' className='form-control-color' value={updateThemeCustomizer.values.dark_theme_colors.sidebar_color_text} onChange={e => updateThemeCustomizer?.setFieldValue('dark_theme_colors.sidebar_color_text', e.target.value)} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="button-form mt-4">
                  <button
                    type="submit"
                    className={`btn btn-primary w-10 ${addSubmissionLoader ? 'btn-loader' : ''}`}
                    disabled={addSubmissionLoader || !isFormFilled}
                  >
                    {t('Submit')}
                  </button>
                  <button
                    type="button"
                    className={`btn btn-secondary w-10 ms-2 text-white ${addResetSettingLoader ? 'btn-loader' : ''}`}
                    onClick={() => { handleResetSetting() }}
                    disabled={addResetSettingLoader}
                  >
                    {t('Reset Settings')}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}




